if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        const idInput = this.form?.querySelector('[name=id]');
        if (idInput) {
          idInput.disabled = false;
        }

        this.form?.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        if (
          document.querySelector('cart-drawer') &&
          this.submitButton
        ) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const isCartUpsell =
          !!this.closest('.cart-upsell-card');

        if (!this.submitButton) {
          return;
        }

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        const spinner =
          this.querySelector(
            '.loading-overlay__spinner'
          );

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config =
          fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData =
          new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        config.body = formData;

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) =>
            response.json()
          )
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              const normalText =
                this.submitButton.querySelector(
                  'span:not(.sold-out-message)'
                );

              if (normalText) {
                normalText.classList.add(
                  'hidden'
                );
              }

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location =
                window.routes.cart_url;

              return;
            }

            if (!this.error) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form'
                }
              );
            }

            this.error = false;

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {

  document.body.addEventListener(
    'modalClosed',
    () => {

      setTimeout(() => {
        this.cart.renderContents(response);
      });

    },
    { once: true }
  );

  quickAddModal.hide(true);

} else {

  this.cart.renderContents(response);


  /* =========================================
     SUCCESS NUR FÜR CART-UPSELL
     ========================================= */

  if (isCartUpsell) {

    window.setTimeout(() => {

      /*
       * renderContents() hat den Drawer bereits
       * neu aufgebaut.
       *
       * Deshalb suchen wir bewusst den NEUEN
       * Upsell-Button im neuen DOM.
       */

      const newButton =
        document.querySelector(
          '.cart-upsell-card .quick-add__submit'
        );


      if (!newButton) {
        return;
      }


      const newButtonText =
        newButton.querySelector(
          'span:not(.sold-out-message)'
        );


      if (!newButtonText) {
        return;
      }


      /*
       * Erfolgszustand
       */

      newButton.classList.add(
        'cart-upsell-added'
      );

      newButton.setAttribute(
        'aria-disabled',
        'true'
      );

      newButtonText.textContent =
        '✓ Hinzugefügt';


      /*
       * Nach 2 Sekunden wieder normal
       */

      window.setTimeout(() => {

        newButton.classList.remove(
          'cart-upsell-added'
        );

        newButton.removeAttribute(
          'aria-disabled'
        );

        newButtonText.textContent =
          'Hinzufügen';

      }, 2000);


    }, 150);

  }

}

            this.initializeShippingToggle();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            const spinner =
              this.querySelector(
                '.loading-overlay__spinner'
              );

            if (spinner) {
              spinner.classList.add(
                'hidden'
              );
            }
          });
      }

      initializeShippingToggle() {
        const shippingToggle =
          document.querySelector(
            '#shipping-product-toggle'
          );

        if (!shippingToggle) {
          return;
        }

        const mainCartItems =
          document.querySelectorAll(
            '.lk-cart-drawer-items .cart-item'
          );

        const productId =
          shippingToggle.getAttribute(
            'data-product-id'
          );

        mainCartItems.forEach(
          (item) => {
            if (
              item.getAttribute(
                'data-variant-id'
              ) === productId
            ) {
              shippingToggle.checked =
                true;
            }
          }
        );

        /*
         * Verhindert, dass nach jedem
         * Drawer-Refresh mehrere identische
         * Event Listener gesetzt werden.
         */
        if (
          shippingToggle.dataset
            .listenerInitialized === 'true'
        ) {
          return;
        }

        shippingToggle.dataset
          .listenerInitialized = 'true';

        shippingToggle.addEventListener(
          'change',
          function () {
            const cartItems =
              document.querySelectorAll(
                '.lk-cart-drawer-items .cart-item'
              );

            let priorityItem = null;

            cartItems.forEach(
              (item) => {
                if (
                  item.getAttribute(
                    'data-variant-id'
                  ) ==
                  this.getAttribute(
                    'data-product-id'
                  )
                ) {
                  priorityItem =
                    item;
                }
              }
            );

            if (this.checked) {
              if (!priorityItem) {
                const wrapper =
                  this.closest(
                    '.shipping-product__wrapper'
                  );

                const addButton =
                  wrapper?.querySelector(
                    '.product-form__submit'
                  );

                if (addButton) {
                  addButton.click();
                }
              }
            } else {
              if (priorityItem) {
                const removeButton =
                  priorityItem.querySelector(
                    'cart-remove-button'
                  );

                if (removeButton) {
                  removeButton.click();
                }
              }
            }
          }
        );
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    }
  );
}


document.addEventListener(
  'variant:changed',
  (event) => {
    const variant =
      event.detail.variant;

    const bisWrapper =
      document.querySelector(
        '#klaviyo-bis-trigger-wrapper'
      );

    const bisTrigger =
      document.querySelector(
        '.klaviyo-bis-trigger'
      );

    if (
      !variant ||
      !bisWrapper ||
      !bisTrigger
    ) {
      return;
    }

    bisTrigger.setAttribute(
      'data-variant',
      variant.id
    );

    if (variant.available) {
      bisWrapper.style.display =
        'none';
    } else {
      bisWrapper.style.display =
        'block';
    }
  }
);